// extracted by mini-css-extract-plugin
module.exports = {"popper-content":"_24-IN","popperContent":"_24-IN"};